import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Vant from 'vant';

Vue.use(Vant);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
